'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { UserType } from '@/types/pam-api';
import useUser from '@/utils/use-user';
import { GTM_ID, IS_SET_USER_ATTRIBUTE_STORAGE_KEY } from './constants';
import { sendPageViewEvent, sendUserAttributesEvent, sendUserIdEvent } from './datalayer';
import { WindowWithDataLayer } from './types';
declare const window: WindowWithDataLayer;
export default function GTMBody() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    isLoggedIn,
    user
  } = useUser();
  useEffect(() => {
    if (!pathname || typeof window.dataLayer === 'undefined') return;
    sendPageViewEvent({
      page: pathname
    });
    if (isLoggedIn && sessionStorage.getItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY) !== 'set') {
      sendUserAttributesEvent({
        data: {
          logged_in: isLoggedIn ? 'true' : 'false',
          user_id: user?.id || null,
          aov: user?.aov || null,
          user_type: user?.userType ? user.userType.toLowerCase() as Lowercase<UserType> : null,
          total_order: user?.totalOrder ?? 0,
          last_purchase: user?.lastPurchaseDay ?? null,
          city: user?.lastAddressCityName ?? null,
          province: user?.lastAddressProvinceName ?? null
        }
      });
      sendUserIdEvent({
        user_id: user?.id || null
      });
      sessionStorage.setItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY, 'set');
    }
  }, [pathname, searchParams, isLoggedIn, user?.id, user?.aov, user?.userType, user?.totalOrder, user?.lastPurchaseDay, user?.lastAddressCityName, user?.lastAddressProvinceName]);
  return <noscript data-sentry-component="GTMBody" data-sentry-source-file="gtm-body.tsx">
            <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height='0' width='0' className='invisible hidden' title='GTAG'></iframe>
        </noscript>;
}